import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from '../shared/auth.service';

@Injectable({ providedIn: 'root' })
export class HTTPInterceptor implements HttpInterceptor {
  private tokenPromise: Promise<string | null> | null = null;

  constructor(private auth: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = this.normalizeUrl(req.url);
    let apiReq = req.clone({ url });

    // Set app type header to identify student-app/mobile-app requests
    // This differentiates mobile app from teacher-dashboard
    apiReq = apiReq.clone({ 
      setHeaders: { 'X-App-Type': 'student-app' } 
    });

    // 🔑 WICHTIG: Wenn kein User eingeloggt ist → kein Token versuchen
    // (z.B. bei /auth/login, /user/get-email, /register, etc.)
    if (!this.auth.fireUser) {
      // Optional: bestimmte URLs immer ohne Token lassen
      // if (req.url.includes('user/get-email') || req.url.includes('auth/login')) {
      //   return next.handle(apiReq);
      // }

      return next.handle(apiReq);
    }

    // Ab hier: User ist eingeloggt → Token holen (mit Promise-Caching)
    const tokenPromise =
      this.tokenPromise ||
      this.auth.getToken().then(token => {
        this.tokenPromise = null;
        return token || null;
      });

    if (!this.tokenPromise) {
      this.tokenPromise = tokenPromise;
    }

    return from(tokenPromise).pipe(
      switchMap(token => {
        if (token) {
          const authHeader = `Bearer ${token}`;
          // Set both headers together to avoid overwriting X-App-Type
          apiReq = apiReq.clone({ 
            setHeaders: { 
              'Authorization': authHeader,
              'X-App-Type': 'student-app'
            } 
          });
        }
        return next.handle(apiReq);
      }),
      catchError(error => {
        console.error(
          '🔍 Token retrieval failed, proceeding without auth. Error:',
          error?.message || error
        );
        // Im Fehlerfall trotzdem ohne Token weitermachen
        return next.handle(apiReq);
      })
    );
  }

  private normalizeUrl(original: string): string {
    if (/^https?:\/\//i.test(original)) return original;
    const base = (environment.baseUrl || '').replace(/\/+$/, '');
    const path = String(original || '').replace(/^\/+/, '');
    return base ? `${base}/${path}` : `/${path}`;
  }
}
